<p-dialog
  [maximizable]="true"
  class="filters-modal add-cashout"
  header="Nuevo cashout {{ ctx.currency }}"
  [modal]="true"
  [(visible)]="ctx.showNewTransaction"
  [style]="{ width: '1100px' }"
  *ngIf="ctx.showNewTransaction"
  (visibleChange)="ctx.closeAddModal()"
>
  <div class="new-transaction-form">
    <div class="form-heading">
      <div class="form-title">
        Cashout Notbank ({{ ctx.currency }}) — banco / PIX destino
      </div>
    </div>

    <div class="form-scroll-wrapper">
      <form class="form-container" [formGroup]="ctx.newTransactionForm">
        <div class="form-row">
          <div class="filter-column">
            <div class="form-item" *ngIf="ctx.auth.hasRole(ctx.roles.Admin)">
              <label>Cliente asignado</label>
              <p-dropdown
                placeholder="Elige un cliente"
                formControlName="client_id"
                [options]="ctx.userService.users"
                optionLabel="username"
                [filter]="true"
                filterBy="username"
                appendTo="body"
              />
            </div>

            <div class="form-item">
              <label>Nombre</label>
              <input pInputText formControlName="firstname" class="w-full" />
            </div>
            <div class="form-item">
              <label>Apellido</label>
              <input pInputText formControlName="lastname" class="w-full" />
            </div>
            <div class="form-item">
              <label>Monto ({{ ctx.currency }})</label>
              <input pInputText formControlName="amount" class="w-full" />
            </div>
            <div class="form-item">
              <label>Proveedor / subwallet</label>
              <p-dropdown
                formControlName="company_id"
                [options]="ctx.getBanks()"
                optionLabel="name"
                [filter]="true"
                filterBy="name"
                placeholder="NOTBANK_{{ ctx.currency }}"
                appendTo="body"
                (onChange)="ctx.onBankChange?.($event)"
              />
            </div>
          </div>

          <div class="filter-column" formGroupName="notbank_bank">
            <div class="form-item">
              <label>Banco Notbank</label>
              <p-dropdown
                formControlName="bank"
                [options]="notbankBanks"
                optionLabel="label"
                [filter]="true"
                filterBy="label,name"
                [loading]="loadingBanks"
                placeholder="Selecciona banco"
                appendTo="body"
                styleClass="w-full"
              />
            </div>
            <div class="form-item">
              <label>Tipo de cuenta</label>
              <p-dropdown
                formControlName="kind"
                [options]="kindOptions"
                optionLabel="label"
                optionValue="value"
                (onChange)="onKindChange()"
                appendTo="body"
                styleClass="w-full"
              />
            </div>
            <div class="form-item" *ngIf="isPix">
              <label>Tipo de clave PIX</label>
              <p-dropdown
                formControlName="pix_type"
                [options]="pixTypeOptions"
                optionLabel="label"
                optionValue="value"
                appendTo="body"
                styleClass="w-full"
              />
            </div>
            <div class="form-item">
              <label>{{ isPix ? 'Clave PIX' : 'Número de cuenta' }}</label>
              <input pInputText formControlName="number" class="w-full" />
            </div>
            <ng-container *ngIf="country === 'BR' && !isPix">
              <div class="form-item">
                <label>Agencia</label>
                <input pInputText formControlName="agency" class="w-full" />
              </div>
              <div class="form-item">
                <label>DV</label>
                <input pInputText formControlName="dv" class="w-full" />
              </div>
            </ng-container>
            <div class="form-item" *ngIf="country === 'PE'">
              <label>Provincia</label>
              <p-dropdown
                formControlName="province"
                [options]="notbankProvinces"
                optionLabel="label"
                [filter]="true"
                appendTo="body"
                styleClass="w-full"
              />
            </div>
            <ng-container *ngIf="ctx.currency === 'ARS'">
              <div class="form-item">
                <label>CBU</label>
                <input pInputText formControlName="cbu" class="w-full" />
              </div>
              <div class="form-item">
                <label>CUIT</label>
                <input pInputText formControlName="cuit" class="w-full" />
              </div>
              <div class="form-item">
                <label>Tipo persona</label>
                <p-dropdown
                  formControlName="person_type"
                  [options]="[
                    { value: 'F', label: 'Física (F)' },
                    { value: 'J', label: 'Jurídica (J)' }
                  ]"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                />
              </div>
            </ng-container>
          </div>
        </div>
      </form>
    </div>

    <div class="buttons-container">
      <p-button
        label="Cancelar"
        severity="danger"
        (click)="ctx.exitNewTransaction()"
      />
      <p-button
        label="Continuar"
        severity="secondary"
        (click)="saveTransaction()"
      />
    </div>
  </div>
</p-dialog>
